import "regenerator-runtime/runtime.js";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.promise.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* eslint-disable prefer-destructuring */
import React, { useEffect, useRef, useState } from 'react';
import { Button, useIsMounted } from 'components';
import { Modal } from 'components/UI';
import { showApiError } from 'utils';
import { getAnaCreditNewCredit } from 'services';
import { tableHeader, tableWrap, tableSectionTitle, reportTable, emptyTable } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var NewCreditAnaCredit = function NewCreditAnaCredit() {
  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      newCreditAnaCredit = _useState2[0],
      setNewCreditAnaCredit = _useState2[1];

  var isMounted = useIsMounted();
  var demoModalRef = useRef(null);
  useEffect(function () {
    fetchNewCreditAnaCredit();
  }, []);

  var fetchNewCreditAnaCredit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$getAnaCreditNe, _yield$getAnaCreditNe2, res, err, tables;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getAnaCreditNewCredit({
                "export": 0
              });

            case 2:
              _yield$getAnaCreditNe = _context.sent;
              _yield$getAnaCreditNe2 = _slicedToArray(_yield$getAnaCreditNe, 2);
              res = _yield$getAnaCreditNe2[0];
              err = _yield$getAnaCreditNe2[1];

              if (!err) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", showApiError(err));

            case 8:
              if (isMounted.current) {
                _context.next = 10;
                break;
              }

              return _context.abrupt("return");

            case 10:
              tables = Object.entries(res).map(function (_ref2) {
                var _ref3 = _slicedToArray(_ref2, 2),
                    key = _ref3[0],
                    value = _ref3[1];

                var arr = _toConsumableArray(value !== null && value !== void 0 ? value : []);

                var colNames = arr === null || arr === void 0 ? void 0 : arr.shift();
                return {
                  name: key,
                  colNames: colNames,
                  items: arr
                };
              });
              setNewCreditAnaCredit(tables);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchNewCreditAnaCredit() {
      return _ref.apply(this, arguments);
    };
  }();

  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Modal, {
    ref: demoModalRef
  }, ___EmotionJSX("h4", {
    className: "mb1"
  }, "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F"), ___EmotionJSX("p", {
    className: "mb1"
  }, "\u0411\u0438\u0445\u043C\u0435 \u0438\u0441\u043A\u0430\u043B\u0438 \u0434\u0430 \u0412\u0438 \u0443\u0432\u0435\u0434\u043E\u043C\u0438\u043C, \u0447\u0435 \u0442\u043E\u0432\u0430 \u0435 \u0434\u0435\u043C\u043E\u043D\u0441\u0442\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u0430 \u0441\u0440\u0435\u0434\u0430, \u043F\u043E\u0440\u0430\u0434\u0438 \u043A\u043E\u0435\u0442\u043E \u0444\u0430\u0439\u043B\u043E\u0432\u0435\u0442\u0435 \u043D\u0435 \u043C\u043E\u0433\u0430\u0442 \u0434\u0430 \u0431\u044A\u0434\u0430\u0442 \u0441\u0432\u0430\u043B\u044F\u043D\u0438."), ___EmotionJSX("div", {
    css: function css(t) {
      return t.displayFlex({
        justify: 'flex-end'
      });
    }
  }, ___EmotionJSX(Button, {
    type: "secondary",
    onClick: function onClick() {
      return demoModalRef.current.close();
    }
  }, "\u0417\u0430\u0442\u0432\u043E\u0440\u0438"))), ___EmotionJSX("div", {
    css: tableHeader
  }, ___EmotionJSX("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.8em'
    }
  }, ___EmotionJSX("i", {
    className: "las la-info-circle info-icon"
  }), ___EmotionJSX("p", null, "\u041C\u043E\u043B\u044F, \u043D\u0430\u043F\u0440\u0430\u0432\u0435\u0442\u0435 \u0435\u043A\u0441\u043F\u043E\u0440\u0442 \u043D\u0430\u0439-\u043A\u044A\u0441\u043D\u043E 5 \u0440\u0430\u0431\u043E\u0442\u043D\u0438 \u0434\u043D\u0438 \u0441\u043B\u0435\u0434 \u0430\u043A\u0442\u0438\u0432\u0438\u0440\u0430\u043D\u0435/\u0437\u0430\u043A\u0440\u0438\u0432\u0430\u043D\u0435 \u043D\u0430 \u043A\u0440\u0435\u0434\u0438\u0442. \u0410\u043A\u043E \u043D\u044F\u043C\u0430 \u0434\u0430\u043D\u043D\u0438, \u043D\u044F\u043C\u0430 \u0441\u043C\u0438\u0441\u044A\u043B \u0434\u0430 \u0441\u0435 \u043F\u0440\u0430\u0432\u0438 \u0435\u043A\u0441\u043F\u043E\u0440\u0442.")), ___EmotionJSX(Button, {
    small: true,
    type: "info",
    onClick: function onClick() {
      return demoModalRef.current.open();
    },
    leftIcon: {
      iconName: 'la la-file-excel',
      size: 20
    }
  }, "\u0415\u043A\u0441\u043F\u043E\u0440\u0442")), (newCreditAnaCredit === null || newCreditAnaCredit === void 0 ? void 0 : newCreditAnaCredit.length) > 0 ? newCreditAnaCredit.map(function (table) {
    var _table$colNames, _table$items, _table$colNames2;

    return ___EmotionJSX("div", {
      key: table.name,
      css: tableWrap
    }, ___EmotionJSX("div", {
      css: tableSectionTitle
    }, ___EmotionJSX("i", {
      className: "las la-table"
    }), table.name), ___EmotionJSX("table", {
      css: reportTable
    }, ___EmotionJSX("thead", null, ___EmotionJSX("tr", null, table === null || table === void 0 ? void 0 : (_table$colNames = table.colNames) === null || _table$colNames === void 0 ? void 0 : _table$colNames.map(function (col) {
      return ___EmotionJSX("th", {
        key: col
      }, col);
    }))), ___EmotionJSX("tbody", null, (table === null || table === void 0 ? void 0 : (_table$items = table.items) === null || _table$items === void 0 ? void 0 : _table$items.length) > 0 ? table.items.map(function (row, i) {
      return ___EmotionJSX("tr", {
        key: i
      }, Object.entries(row !== null && row !== void 0 ? row : {}).map(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
            label = _ref5[0],
            value = _ref5[1];

        return ___EmotionJSX("td", {
          key: label
        }, value);
      }));
    }) : ___EmotionJSX("tr", null, ___EmotionJSX("td", {
      colSpan: (table === null || table === void 0 ? void 0 : (_table$colNames2 = table.colNames) === null || _table$colNames2 === void 0 ? void 0 : _table$colNames2.length) || 1,
      css: emptyTable
    }, "\u041D\u044F\u043C\u0430 \u0434\u0430\u043D\u043D\u0438")))));
  }) : null);
};

export default NewCreditAnaCredit;